import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { ClassToggleService, HeaderComponent } from '@coreui/angular';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {
  @Input() sidebarId: string = 'sidebar';

  public newMessages = new Array(4);
  public newTasks = new Array(5);
  public newNotifications = new Array(5);
  public livedatetime: string = '';

  constructor(
    private classToggler: ClassToggleService,
    private router: Router
  ) {
    super();
    setInterval(() => {
      let datetime_str = new Date().toLocaleString('en-US', {
        timeZone: 'Asia/Manila',
      });
      this.livedatetime = datetime_str;
    }, 1000);
  }

  Logout() {
    this.router.navigate(['login']);
    localStorage.clear();
  }
}
